import styled from "styled-components";
import { Input, Table } from "antd";
import { COLORS } from "../../../../layout/theme";

export const StepContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 20px;
`;

export const HeaderContainer = styled.div`
	display: flex;
	gap: 40px;
	padding: 20px;
	background-color: ${COLORS.White};
	border-radius: 5px;
`;

export const BodyContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export const AntdTable = styled(Table)`
	& .noBackground,
	& .noBackground:hover {
		background-color: ${COLORS.LightGrey} !important;
		border: none;
	}

	.ant-table-thead > tr > th {
		background: ${COLORS.White};
	}

	.ant-table-tbody > tr > td {
		border-bottom: 0px solid ${COLORS.White};
	}

	.ant-table-thead
		> tr
		> th:not(:last-child):not(.ant-table-selection-column):not(
			.ant-table-row-expand-icon-cell
		):not([colspan])::before {
		background-color: ${COLORS.White};

		div {
			color: ${COLORS.DarkGrey};
		}
	}

	thead {
		border-color: ${COLORS.White};
		border: 1px solid ${COLORS.White};
	}

	.ant-table-thead th.ant-table-column-has-sorters:hover {
		background: ${COLORS.Secondary};
	}

	.ant-table-column-sorter {
		color: ${COLORS.White};
	}
`;

export const Section = styled.div`
	display: flex;
	justify-content: flex-start;
	cursor: pointer;
	gap: 15px;
`;

export const CompaginationDiv = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
`;

export const AntdInput = styled(Input)`
	.ant-input-group .ant-input {
		border: 1px solid ${COLORS.Grey};
		border-radius: 10px;
		background-color: transparent;
		text-align: end;
		padding: 5px;
	}

	.ant-input-group .ant-input:hover {
		border: 1px solid ${COLORS.Secondary};
		border-radius: 10px;
	}

	.ant-input-group .ant-input:focus {
		border-radius: 10px;
	}

	.ant-input-group-addon {
		border: 0;
		background-color: transparent;
		padding: 5px;
	}
`;

export const FilterContainer = styled.div`
	display: flex;
	gap: 20px;
	justify-content: space-between;
	align-items: center;
`;

export const TextContainer = styled.div`
	${(props) =>
		props.pointer &&
		`
  cursor: pointer;
`}
	width: 100%;
	white-space: nowrap;
	overflow: hidden !important;
	text-overflow: ellipsis;
`;
